import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("关闭")

import { PropType, ref } from "vue";
import { TeamService } from "@/views/project/team/team.service";
import { DEFAULTCOUNTMAX, DEFAULTPRICELENGTH, DEFAULTTABLEMAXHEIGHT } from "@/core/constant";
import { message } from "ant-design-vue";
import { columns } from "./constant";
import { WarehouseService } from "@/views/material/manage/manage.service";
import { PaginationReq } from "@/core";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  row: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
},
  emits: ["refresh"],
  setup(__props, { emit: emits }) {

const props = __props


const {
  run: runWarehouse,
  loading: wareLoading,
  pagination: pagination,
  data:dataSource
} = WarehouseService.usePricePageApi();

const visible = ref(false);
const params= new PaginationReq()
const showModal = async () => {
  await search()
  visible.value = true;
};
const search=async () => {
  params.current=1;
  params['materialId']=props.row.materialId
  params['repertotyId']=props.row.repertotyId
  
  await runWarehouse(params);
}
const handleOk = () => {
  visible.value = false;
};
const onTableChange=async(e)=>{
  params.current = e.current;
  params.size = e.pageSize;
  params['materialId']=props.row.materialId
  await runWarehouse(params);
}

return (_ctx: any,_cache: any) => {
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: showModal
        }, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      centered: true,
      maskClosable: false,
      width: "1200px",
      title: __props.row?.materialNo + __props.row?.materialName + '库存单价变化',
      onOk: handleOk
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: handleOk
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_table_wrapper, {
          "row-key": 'uuid',
          dataSource: _unref(dataSource),
          columns: _unref(columns),
          showCheckbox: false,
          showTooTip: false,
          maxHeight: _unref(DEFAULTTABLEMAXHEIGHT),
          tableHeight: 600,
          pagination: _unref(pagination),
          loading: _unref(wareLoading),
          onOnTableChange: onTableChange
        }, null, 8, ["dataSource", "columns", "maxHeight", "pagination", "loading"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})